// src/store/slices/employeeLogSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import employeeLogApi from 'api/employeeLogApi';

// export const fetchLogs = createAsyncThunk(
//   'employeeLog/fetchLogs',
//   async ({ page = 1, pageSize = 10, search = '' }, { rejectWithValue }) => {
//     try {
//       const response = await employeeLogApi.getAll(page, pageSize, search,params.resource || null);
//       return response;
//     } catch (err) {
//       return rejectWithValue(err.response?.data?.detail || 'Failed to load logs');
//     }
//   }
// );

// src/store/slices/employeeLogSlice.js

export const fetchLogs = createAsyncThunk(
  'employeeLog/fetchLogs',
  async (params = {}, { rejectWithValue }) => {
    try {
      // Pass the entire params object directly
      const response = await employeeLogApi.getAll(
        params.page || 1,
        params.pageSize || 10,
        params.search || '',
        params.resource || null   // This is the key!
      );
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || 'Failed to load logs');
    }
  }
);

const employeeLogSlice = createSlice({
  name: 'employeeLog',
  initialState: {
    logs: [],
    pagination: {
      next: null,
      previous: null,
      count: 0,
      page_size: 10,
      current_page: 1,
    },
    isLoading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLogs.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchLogs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.logs = action.payload.data || [];
        state.pagination = {
          ...action.payload.pagination,
          page_size: action.payload.pagination.page_size || 10,
        };
      })
      .addCase(fetchLogs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = employeeLogSlice.actions;
export default employeeLogSlice.reducer;